import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { CommonModule } from '@angular/common'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { ButtonComponent } from '../button/button.component'
import { LinkComponent } from '../link/link.component'
import { GalleryGridComponent } from '../gallery-grid/gallery-grid.component'
import { ApiService, UserInfo } from '../../services/api.service'
import { Gallery } from '../../interfaces/api/Gallery'
import { GalleryImage } from '../../interfaces/api/GalleryImage'
import { UserRole } from 'app/interfaces/api/UserRole'


interface BannerData {
  // title: string;  <-- eliminado
  imageUrl: string;
  smallImageUrl: string;
  link: string;
}


interface BannerEntry {
  country: string;        // ahora ISO code (alpha-2)
  countryName?: string;   // nombre legible / original (opcional)
  // byUserType se mantiene flexible para evitar errores al tener datos antiguos con "title"
  byUserType: any;
}

@Component({
    selector: 'app-banners',
    templateUrl: './home-banners.component.html',
    styleUrls: ['./home-banners.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule],
})
export class HomeBannersComponent implements OnInit {
    userInfo: UserInfo | null = null
    userRole = UserRole
    banners: any
    constructor(private api: ApiService, private translate: TranslateService) {}

    showPopup = false
    showPopup1 = false
    showPopup2 = false

    ngOnInit(): void {
        // asegúrate del nombre del observable en ApiService (userInfo / userInfo$)
        this.api.userInfo?.subscribe((u) => {
            this.userInfo = u
            console.debug('HomeBanners userInfo set:', u)
            this.fetchBanners()
        })

        // Re-fetch banners when user changes language in the app
        this.translate.onLangChange.subscribe(() => {
            this.fetchBanners()
        })

        // Espera a que userInfo y banners estén listos
        // setTimeout(() => {


        //     // Si es designer, no mostrar ningún popup
        //     if ((this.userInfo?.accountType ?? '').toLowerCase() === 'designer') {
        //         this.showPopup = false
        //         this.showPopup1 = false
        //         this.showPopup2 = false
        //         return
        //     }

        //     // Lógica para mostrar popup1 o popup2
        //     if (langBanners?.popup1?.imageUrl) {
        //         this.showPopup = true
        //         this.showPopup1 = true
        //         this.showPopup2 = false
        //     } else if (langBanners?.popup2?.imageUrl) {
        //         this.showPopup = true
        //         this.showPopup1 = false
        //         this.showPopup2 = true
        //     } else {
        //         this.showPopup = false
        //         this.showPopup1 = false
        //         this.showPopup2 = false
        //     }
        // }, 0)
    }



    closePopup() {
        this.showPopup = false
        this.showPopup1 = false
        this.showPopup2 = false
    }

    /**
     * Returns the base language code for the banner API.
     * Normalizes locale variants: fr-ca → fr, en-gb → en, en-au → en, etc.
     */
    private getBannerLanguage(): string {
        const lang = (this.translate.currentLang || this.translate.getDefaultLang() || 'en').toLowerCase()
        return lang.split('-')[0]
    }

    private fetchBanners(): void {
        if (!this.userInfo) return
        const language = this.getBannerLanguage()
        this.getBannersForCountry(
            this.userInfo.country ?? '',
            this.userInfo.accountType ?? '',
            language,
            this.userInfo.loyaltyLevel ?? '',
            this.userInfo.sapCenterId ?? ''
        )
    }

    /**
     * Devuelve el set de banners (banner1/banner2) para el país y userType actual.
     * Retorna null si no hay coincidencias o no hay userInfo.
     */
    getBannersForCountry(country: string, userType: string, language: string, loyaltyLevel: string, sapCenterId: string): any | null {
        console.log('Getting banners for country:', country, 'and userType:', userType, 'and language:', language, 'and loyaltyLevel:', loyaltyLevel, 'and sapCenterId:', sapCenterId);
        if (!country || !userType || !language || !loyaltyLevel || !sapCenterId) return null

        this.api.getBanners(country.toLowerCase(), userType.toLowerCase(), language.toLowerCase(), loyaltyLevel.toLowerCase(), sapCenterId.toLowerCase()).subscribe((data) => {
            this.banners = data;
            console.log('Banners data from API:', this.banners);
        });
        return this.banners;





        // const rawCountry = String(country).trim()
        // const candidate = rawCountry.length <= 3 ? rawCountry.toUpperCase() : rawCountry.toLowerCase()

        // // buscar primero por ISO exacto (country field)
        // let entry = (this.banners || []).find((b: BannerEntry) => String(b.country).toUpperCase() === candidate)
        // if (!entry) {
        //     // si no hay ISO, intentar extraer ISO entre paréntesis (ej. "USA (CTOP 2.0)" -> "USA" -> "US")
        //     const isoMatch = rawCountry.match(/\b([A-Z]{2,3})\b/i)
        //     if (isoMatch) {
        //         const iso = isoMatch[1].toUpperCase()
        //         entry = (this.banners || []).find((b: BannerEntry) => String(b.country).toUpperCase() === iso)
        //     }
        // }
        // if (!entry) {
        //     // fallback: buscar comparando countryName (contains, case-insensitive)
        //     entry = (this.banners || []).find((b: BannerEntry) => {
        //         if (!b.countryName) return false
        //         return String(b.countryName).toLowerCase().includes(rawCountry.toLowerCase()) || rawCountry.toLowerCase().includes(String(b.countryName).toLowerCase())
        //     })
        // }

        // if (!entry) {
        //     console.debug('Banners: no entry for country', country)
        //     return null
        // }

        // // obtener la key del userType desde userInfo.accountType y normalizar
        // const roleKey = String((this.userInfo as any).accountType ?? '')
        //     .trim()
        //     .toLowerCase()
        // if (!roleKey) return null

        // const userBanners = entry.byUserType?.[roleKey] ?? null
        // if (!userBanners) {
        //     console.debug('Banners: no banners for role', roleKey, 'in country', entry.country)
        //     return null
        // }

        // console.log('Banners for', country, 'and userType', roleKey, ':', userBanners)

        // return userBanners // objeto con banner1 y banner2
    }

    // Lógica de banners: ahora agrupados por userType (byUserType) por país y language
    // banners: BannerEntry[] = [
    //     {
    //         country: 'ES',
    //         countryName: 'Spain',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             smallImageUrlXs: 'https://via.placeholder.com/320x300?',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Suma',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'PT',
    //         countryName: 'Portugal',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     pt: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Suma',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     pt: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     pt: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     pt: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     pt: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'US',
    //         countryName: 'United States',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Local CTS',
    //                             imageUrl: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/CTA/US/CTA-412x214.jpg',
    //                             smallImageUrl: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/CTA/US/CTA-320x214.jpg',
    //                             smallImageUrlXs: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/CTA/US/CTA-320x300.jpg',
    //                             link: 'https://pre-digital-apps.cosentino.com/ctop-app/bath-quote?projectid=0&quoteid=0&category=WASHBASIN',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Ukiyo',
    //                             imageUrl: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/Ukiyo/EN/UKIYO-412x214.jpg',
    //                             smallImageUrl: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/Ukiyo/EN/UKIYO-320x214.jpg',
    //                             smallImageUrlXs: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/Ukiyo/EN/UKIYO-320x300.jpg',
    //                             link: 'https://www.cosentino.com/usa/silestone/ukiyo/',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Local CTS',
    //                             imageUrl: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/CTA/US/CTA-412x214.jpg',
    //                             smallImageUrl: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/CTA/US/CTA-320x214.jpg',
    //                             smallImageUrlXs: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/CTA/US/CTA-320x300.jpg',
    //                             link: 'https://e.cosentino.com',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Suma',
    //                             imageUrl: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/SUMAV2/EN/SUMA-412x214.jpg',
    //                             smallImageUrl: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/SUMAV2/EN/SUMA-320x214.jpg',
    //                             smallImageUrlXs: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/SUMAV2/EN/SUMA-320x300.jpg',
    //                             link: 'https://www.cosentino.com/usa/silestone/suma/',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Local CTS',
    //                             imageUrl: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/CTA/US/CTA-412x214.jpg',
    //                             smallImageUrl: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/CTA/US/CTA-320x214.jpg',
    //                             smallImageUrlXs: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/CTA/US/CTA-320x300.jpg',
    //                             link: 'wecommerce',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Shop & Shave',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/320x300?retailer2',
    //                             link: '/retailer-promo',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             smallImageUrlXs: 'https://via.placeholder.com/320x300?retailer1',
    //                             link: '/retailer-visit',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'CA',
    //         countryName: 'Canada',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Local CTS',
    //                             imageUrl: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/CTA/US/CTA-412x214.jpg',
    //                             smallImageUrl: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/CTA/US/CTA-412x214.jpg',
    //                             link: 'https://pre-digital-apps.cosentino.com/ctop-app/bath-quote?projectid=0&quoteid=0&category=WASHBASIN',
    //                             smallImageUrlXs: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/CTA/US/CTA-412x214.jpg',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Ukiyo',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/ukiyo-silestone',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Local CTS',
    //                             imageUrl: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/CTA/US/CTA-412x214.jpg',
    //                             smallImageUrl: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/CTA/US/CTA-412x214.jpg',
    //                             link: 'https://pre-digital-apps.cosentino.com/ctop-app/bath-quote?projectid=0&quoteid=0&category=WASHBASIN',
    //                             smallImageUrlXs: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeBanners/CTA/US/CTA-412x214.jpg',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Ukiyo',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/ukiyo-silestone',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'IT',
    //         countryName: 'Italy',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     it: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Suma',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     it: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     it: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     it: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     it: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'FR',
    //         countryName: 'France',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Visita online PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/visita-online-pn',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'GB',
    //         countryName: 'United Kingdom',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'UK Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/uk-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'DE',
    //         countryName: 'Germany',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Germany Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/germany-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'AT',
    //         countryName: 'Austria',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Austria Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/austria-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'BE',
    //         countryName: 'Belgium',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     nl: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'B├ö├Â┬úÔö¼┬½lgica Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/belgica-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'B├ö├Â┬úÔö¼┬½lgica Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/belgica-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'B├ö├Â┬úÔö¼┬½lgica Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/belgica-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     nl: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     nl: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     nl: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     nl: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'SE',
    //         countryName: 'Sweden',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     sv: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Suecia Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/suecia-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     sv: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     sv: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     sv: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     sv: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'DK',
    //         countryName: 'Denmark (F&F)',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     da: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Dinamarca Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/dinamarca-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     da: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     da: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     da: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     da: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'NO',
    //         countryName: 'Norway (coming soon)',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     no: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Noruega Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/noruega-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     no: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     no: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     no: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     no: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'CZ',
    //         countryName: 'Czech Republic',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     cs: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Rep Checa Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/rep-checa-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     cs: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     cs: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     cs: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     cs: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'IE',
    //         countryName: 'Ireland',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Irlanda Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/irlanda-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     ga: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Irlanda Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/irlanda-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     ga: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     ga: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     ga: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     ga: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'CH',
    //         countryName: 'Switzerland',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Suiza Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/suiza-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Suiza Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/suiza-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     it: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Suiza Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/suiza-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     it: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     it: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     it: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     de: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     fr: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     it: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'SE',
    //         countryName: 'Sweden',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     sv: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Suecia Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/suecia-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     sv: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     sv: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     sv: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     sv: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'DK',
    //         countryName: 'Denmark (F&F)',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     da: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Dinamarca Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/dinamarca-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     da: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     da: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     da: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     da: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'NO',
    //         countryName: 'Norway (coming soon)',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     no: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Noruega Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/noruega-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     no: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     no: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     no: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     no: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'CZ',
    //         countryName: 'Czech Republic',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     cs: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Rep Checa Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/rep-checa-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     cs: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     cs: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     cs: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     cs: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'IE',
    //         countryName: 'Ireland',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Irlanda Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/irlanda-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     ga: {
    //                         bannerbottomleft: {
    //                             title: 'Visita online almacén PN',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: 'https://we.cosentino.com/s/form-onlinevisit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Irlanda Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/irlanda-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     ga: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     ga: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     ga: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     en: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                     ga: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'MY',
    //         countryName: 'Malasia (coming soon)',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     ms: {
    //                         bannerbottomleft: {
    //                             title: 'Malasia Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/malasia-banner1',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Malasia Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/malasia-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     ms: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     ms: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     ms: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     ms: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'MX',
    //         countryName: 'M├ö├Â┬úÔö¼┬½xico',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'M├ö├Â┬úÔö¼┬½xico Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/mexico-banner1',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'M├ö├Â┬úÔö¼┬½xico Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/mexico-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'CO',
    //         countryName: 'Colombia',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Colombia Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/colombia-banner1',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Colombia Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/colombia-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'AR',
    //         countryName: 'Argentina',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Argentina Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/argentina-banner1',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Argentina Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/argentina-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'CL',
    //         countryName: 'Chile',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Chile Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/chile-banner1',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Chile Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/chile-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     es: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'BR',
    //         countryName: 'Brasil',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     pt: {
    //                         bannerbottomleft: {
    //                             title: 'Brasil Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/brasil-banner1',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                           },
    //                         bannerbottomright: {
    //                             title: 'Brasil Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/brasil-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     pt: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     pt: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     pt: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     pt: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     {
    //         country: 'JP',
    //         countryName: 'Japan',
    //         byUserType: {
    //             designer: {
    //                 bylanguage: {
    //                     ja: {
    //                         bannerbottomleft: {
    //                             title: 'Japan Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/japan-banner1',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Japan Banner 2',
    //                             imageUrl: 'https://via.placeholder.com/300x150',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300',
    //                             link: '/japan-banner2',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             fabricator: {
    //                 bylanguage: {
    //                     ja: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             kb: {
    //                 bylanguage: {
    //                     ja: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             installer: {
    //                 bylanguage: {
    //                     ja: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //             architect: {
    //                 bylanguage: {
    //                     ja: {
    //                         bannerbottomleft: {
    //                             title: 'Retailer Banner 1',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer1',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer1',
    //                             link: '/retailer-visit',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer1',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         bannerbottomright: {
    //                             title: 'Retailer Promo',
    //                             imageUrl: 'https://via.placeholder.com/300x150?retailer2',
    //                             smallImageUrl: 'https://via.placeholder.com/343x300?retailer2',
    //                             link: '/retailer-promo',
    //                             smallImageUrlXs: 'https://via.placeholder.com/343x300?retailer2',
    //                             XlImageUrl: 'https://via.placeholder.com/343x300',
    //                         },
    //                         popup1: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                         popup2: {
    //                             title: 'PopUp Example',
    //                             imageUrl: 'https://via.placeholder.com/300x150?popup',
    //                             link: 'https://www.cosentino.com/it-it/silestone/suma/',
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    // ]
}
